import usFlag from "../assets/images/flags/us.jpg";
import russiaFlag from "../assets/images/flags/russia.jpg";
import indiaFlag from "../assets/images/flags/india.svg";

const languages = {
  en: {
    label: "English (US)",
    flag: usFlag,
  },
  hi: {
    label: "हिन्दी (Hindi)",
    flag: indiaFlag,
  },
  te: {
    label: "తెలుగు (Telugu)",
    flag: indiaFlag,
  },
  ru: {
    label: "Русский (Russian)",
    flag: russiaFlag,
  },
  bn: {
    label: "বাংলা (Bangla)",
    flag: indiaFlag,
  },
  ur: {
    label: "اردو (Urdu)",
    flag: indiaFlag,
  },
};

export default languages;
